import { render } from "./BaseTextArea.vue?vue&type=template&id=43cfd874&scoped=true"
import script from "./BaseTextArea.vue?vue&type=script&lang=js"
export * from "./BaseTextArea.vue?vue&type=script&lang=js"

import "./BaseTextArea.vue?vue&type=style&index=0&id=43cfd874&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-43cfd874"

export default script